
import { AlertCircle } from "lucide-react";
import React from "react";

export const AuthWarning = () => {
  return (
    <div className="text-amber-300 text-sm flex items-start gap-2">
      <AlertCircle className="h-5 w-5 flex-shrink-0 mt-0.5" />
      <p>
        Make sure you're using the email and password you registered with. If you haven't created an account yet, 
        please sign up first.
      </p>
    </div>
  );
};
